import { BulkEmailDto } from "../Dto/BulkEmail.dto";
import apiClient from "./api.client.service";

export interface SendEmailDTO {
  event: string;
  dataId: string;
  orgId: string;
  doneByUserId: string | null;
}

class EmailService {
  private readonly APIBaseUrl =
    process.env.REACT_APP_API_BASE_URL ?? "https://api.qualifyme.ai";

  async sendEmail(payload: SendEmailDTO) {
    try {
      const response = await apiClient.post(
        `${this.APIBaseUrl}/notification/send`,
        payload,
      );
      return response.data;
    } catch (error: any) {
      console.error("🚀 ~ EmailService ~ sendEmail ~ error:", error);
      throw error;
    }
  }

  async sendResumeUploadReminder(
    jobApplicationId: string,
    organizationId: string,
  ) {
    const payload: SendEmailDTO = {
      event: "RESUME_UPLOAD_REMINDER",
      dataId: jobApplicationId,
      orgId: organizationId,
      doneByUserId: null,
    };

    return this.sendEmail(payload);
  }

  async sendInterviewRoundReminder(
    jobApplicationId: string,
    organizationId: string,
  ) {
    const payload: SendEmailDTO = {
      event: "ASSESSMENT_COMPLETION_REMINDER",
      dataId: jobApplicationId,
      orgId: organizationId,
      doneByUserId: null,
    };

    return this.sendEmail(payload);
  }

  async sendInterviewSlotReminder(
    jobApplicationId: string,
    organizationId: string,
  ) {
    const payload: SendEmailDTO = {
      event: "INTERVIEW_SLOT_REMINDER",
      dataId: jobApplicationId,
      orgId: organizationId,
      doneByUserId: null,
    };

    return this.sendEmail(payload);
  }

  async sendBulkEmail(payload: BulkEmailDto) {
    try {
      const response = await apiClient.post(
        `${this.APIBaseUrl}/notification/send/bulk`,
        payload,
      );
      return response.data;
    } catch (error: any) {
      console.error("🚀 ~ EmailService ~ sendBulkEmail ~ error:", error);
      return {
        status: false,
        message: error?.message || "Failed to send bulk email",
        data: null,
      };
    }
  }
}

const emailService = new EmailService();

export default emailService;
